function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "31.218"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Group_4962",
  "data-name": "Group 4962",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2709",
  "data-name": "Path 2709",
  d: "M35.116 26.038H4.855V5.181h30.261zm3-23.857H1.855v26.857h36.261z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2091",
  "data-name": "Rectangle 2091",
  d: "M0 0h6.058v6.058H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2092",
  "data-name": "Rectangle 2092",
  transform: "translate(0 25.16)",
  d: "M0 0h6.058v6.058H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2093",
  "data-name": "Rectangle 2093",
  transform: "translate(33.942 25.16)",
  d: "M0 0h6.058v6.058H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2094",
  "data-name": "Rectangle 2094",
  transform: "translate(33.942)",
  d: "M0 0h6.058v6.058H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2095",
  "data-name": "Rectangle 2095",
  transform: "translate(7.702 8.388)",
  d: "M0 0h12.443v8.243H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2096",
  "data-name": "Rectangle 2096",
  d: "M-.75-.75h13.943v9.743H-.75zM11.693.75H.75v6.743h10.943z",
  transform: "translate(17.7 13.76)"
}))));